<template>
  <span></span>
</template>

<script>
  import i18n from '@/i18n';
  import Helper from '@/helper/Helper';
  import Api from '@/api/Api';
  import { uuid } from 'uuidv4';

  export default {
    name: 'BrowserIdentifierHandler',
    props: {},
    mounted: function () {
      const modul = this;
      let browserIdentifier = localStorage.getItem("browserIdentifier")
      if(!browserIdentifier){
        browserIdentifier=uuid();
        localStorage.setItem("browserIdentifier", browserIdentifier)
      }
      modul.$eventBus.$emit('browserIdentifier', browserIdentifier);

    },
    methods: {
      fn() {
        const modul = this;
      },
    },
    components: {},
  };
</script>

<style>
</style>

